import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

const Project = () => {
  const { businessID } = useParams();

  return <Navigate to={`/dashboard/projects/${businessID}/sites`} replace />;
};

export default Project;
